module.exports = __webpack_public_path__ + "img/Streeme-Logo_dark.92f5e4.svg";